/**
 * @module KeyEmitter
 */

/**
 * Event emitter for keys. Processes the "held" event,
 * and makes it available to listeners.
 * @class KeyEmitter
 * @extends Phaser.Events.EventEmitter
 * @param {Phaser.Input.Keyboard.Key} key - input object to filter
 */
const KeyEmitter = new Phaser.Class( {
    Extends: Phaser.Events.EventEmitter,
    initialize: function KeyEmitter ( key ) {
        // Super
        Phaser.Events.EventEmitter.call( this );

        /**
         * Ancestral key input object.
         * @private
         */
        this._key = key;

        /**
         * Whether the key is already down. Used to determine repeats.
         * @type boolean
         * @readonly
         */
        this.isDown = false;

        // Set key to emit events while held.
        key.setEmitOnRepeat( true );

        key.on( this.EVENTS.DOWN, this._onDown, this );
        key.on( this.EVENTS.UP, this._onUp, this );
    },
    
    /**
     * Table of events this object emits.
     * Includes "down", "hold", and "up".
     */
    EVENTS: {
        DOWN: "down",
        HOLD: "hold",
        UP: "up",
    },

    /**
     * Process a keydown event, and determine what events to emit.
     * Emits "down" when the key goes down; emits "hold" after "down",
     * and continues to emit it per OS keyboard repeat rate;
     * emits "up" when the key goes up.
     * @private
     */
    _onDown: function () {
        if ( !this.isDown ) {
            this.emit( this.EVENTS.DOWN );
        }
        this.isDown = true;
        this.emit( this.EVENTS.HOLD );
    },

    /**
     * Process a keyup event and emit events.
     * @private
     */
    _onUp: function () {
        this.isDown = false;
        this.emit( this.EVENTS.UP)
    },

    /**
     * Prepare this object for removal. Remove its listeners.
     */
    destroy: function () {
        this._key.off( "down", this._onDown, this );
        this._key.off( "up", this._onDown, this );
    },
} );

export default KeyEmitter;
